module.exports = __webpack_public_path__ + "img/about-mobile@2x.91bcdb83.jpg";